import React, { useMemo, useEffect } from 'react';
import { Text } from 'rsuite';
import GeneralPageLayout from '../components/layout/GeneralPageLayout';

const MaintainancePage = () => {
  const placeName = useMemo(() => {
    const path = window.location.pathname;
    const normalizedPlaceName =
      path.endsWith('/') && path.length > 1 ? path.slice(0, -1) : path;
    return normalizedPlaceName.split('/').pop();
  }, []);
  const shouldRedirect = useMemo(() => {
    return placeName === 'mn-cass-str-portal';
  }, [placeName]);

  useEffect(() => {
    const destUrl = `https://portal.deckard.com/${placeName}`;
    if (shouldRedirect) {
      setTimeout(() => {
        window.location.replace(destUrl);
      }, 0);
    }
  }, [shouldRedirect, placeName]);

  return (
    <GeneralPageLayout showAccountDropdown={false}>
      <Text
        as="h1"
        className="pb-20"
      >
        {shouldRedirect ? 'One moment' : 'We´ll be back soon!'}
      </Text>
      {shouldRedirect && (
        <Text>Redirecting you to our registration portal</Text>
      )}
      {!shouldRedirect && (
        <>
          <Text>
            The registration system is currently down for maintenance.
          </Text>
          <Text>Please try again later.</Text>
        </>
      )}
    </GeneralPageLayout>
  );
};

export default MaintainancePage;
